import type { BoardCommentView } from '../client/types.js';

const AUTOMATION_MARKER_PREFIX = 'autonomous-team:';

/** Strips the idempotency marker the connector writes for itself (§8.2). */
export function withoutAutomationMarker(body: string): string {
  const marker = body.indexOf(AUTOMATION_MARKER_PREFIX);
  return (marker === -1 ? body : body.slice(0, marker)).trim().replace(/[:\s]+$/u, '');
}

function describe(comment: BoardCommentView, who: string): string {
  const body = withoutAutomationMarker(comment.body);
  if (comment.kind === 'claim') return `${who} took this card`;
  const moved = /^moved to ([\w-]+)/u.exec(body);
  if (moved !== null) return `moved to ${moved[1] ?? ''}`;
  const attached = /^attached (.+)$/u.exec(body);
  if (attached !== null) return `${who} attached ${attached[1] ?? 'a file'}`;
  return body;
}

/** A compact line for Overview; the stored original is never rewritten. */
export function commentSummary(comment: BoardCommentView, who: string): string {
  const authored = comment.summary?.trim();
  const source = authored === undefined || authored === '' ? describe(comment, who) : withoutAutomationMarker(authored);
  const oneLine = source.replace(/\s+/gu, ' ').trim();
  return oneLine.length > 280 ? `${oneLine.slice(0, 277)}…` : oneLine;
}

/** Mechanical bookkeeping belongs under Technical details, not in the human narrative. */
export function isTechnicalComment(comment: BoardCommentView): boolean {
  if (comment.kind === 'claim' || comment.authorId === 'workflow') return true;
  const body = withoutAutomationMarker(comment.body);
  return /^moved to [\w-]+/u.test(body) || /^attached .+$/u.test(body);
}

export function describeTechnicalComment(comment: BoardCommentView, who: string): string {
  return describe(comment, who);
}
